import { render, staticRenderFns } from "./OemLogisticsInfoDialog.vue?vue&type=template&id=eb5d782a&"
import script from "./OemLogisticsInfoDialog.vue?vue&type=script&lang=js&"
export * from "./OemLogisticsInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./OemLogisticsInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports